
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[event]/idle",
      function () {
        return require("private-next-pages/[event]/idle.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[event]/idle"])
      });
    }
  